import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {},
};

const localDataSlice = createSlice({
  name: "localData",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;
      state.data[key] = value; // Dynamically add/update the key-value pair
    },
    removeKey: (state, action) => {
      const key = action.payload;
      delete state.data[key]; // Remove the key from the object
    },
    clearAll: (state) => {
      state.data = {}; // Clear all key-value pairs
    },
  },
});

export const { setKeyValue, removeKey, clearAll } = localDataSlice.actions;

export default localDataSlice.reducer;
